var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_send",
    "data-name": "MDI / send",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_send",
    "data-name": "Path / send",
    d: "M2,21l21-9L2,3v7l15,2L2,14Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiSend);
export default __webpack_public_path__ + "static/media/MDI - send.8dc4ecb62f5ea10908d7caec9e36e68f.svg";
export { ForwardRef as ReactComponent };